import { render, staticRenderFns } from "./selectcompanytype.vue?vue&type=template&id=971d381e&"
import script from "./selectcompanytype.js?vue&type=script&lang=js&"
export * from "./selectcompanytype.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('971d381e')) {
      api.createRecord('971d381e', component.options)
    } else {
      api.reload('971d381e', component.options)
    }
    module.hot.accept("./selectcompanytype.vue?vue&type=template&id=971d381e&", function () {
      api.rerender('971d381e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selectcompanytype.vue"
export default component.exports